import http from '../http';
import { coreURLConstruct, errorPayload, successPayload } from '@/services/formatter';

async function getTenantStreams() {
  try {
    const response = await http({
      url: `/tenants/streams`,
      method: 'get',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getStreamConfigurations(filters = {}) {
  try {
    const params = {
      page: filters.page || 1,
      size: filters.size || 50,
    };

    if (filters.search) params.search = decodeURIComponent(filters.search);
    if (filters.sort) params.sort = filters.sort;

    const response = await http({
      url: `${coreURLConstruct()}/stream-configurations`,
      method: 'GET',
      params,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function getSingleStreamConfiguration(id) {
  try {
    const response = await http({
      url: `${coreURLConstruct()}/stream-configurations/${id}`,
      method: 'GET',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function createStreamConfiguration(data) {
  try {
    const payload = {
      streamId: data.streamId,
      punterDisplayConfigurations: [],
      deviceDisplayConfigurations: [],
    };

    const response = await http({
      url: `${coreURLConstruct()}/stream-configurations`,
      method: 'POST',
      data: payload,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function updateStreamConfiguration(id, data) {
  try {
    const payload = {};

    if (data.punterDisplayConfigurations !== undefined) {
      payload.punterDisplayConfigurations = data.punterDisplayConfigurations;
    }
    if (data.deviceDisplayConfigurations !== undefined) {
      payload.deviceDisplayConfigurations = data.deviceDisplayConfigurations;
    }

    const response = await http({
      url: `${coreURLConstruct()}/stream-configurations/${id}`,
      method: 'PATCH',
      data: payload,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

async function deleteStreamConfiguration(id) {
  try {
    const response = await http({
      url: `${coreURLConstruct()}/stream-configurations/${id}`,
      method: 'DELETE',
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
}

export {
  getTenantStreams,
  getStreamConfigurations,
  getSingleStreamConfiguration,
  createStreamConfiguration,
  updateStreamConfiguration,
  deleteStreamConfiguration,
};
